import { IconProps } from '@tiendanube/icons';
import { icons } from './icons';

export function getIcon(name: string): React.FC<IconProps> {
  return icons[name] || icons['QuestionCircleIcon'];
}
